import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/[locale]/terms-of-service/TermsPageWrapper.tsx");
